import { Box, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { PASSWORD_ALLOWED_SPECIALS, PASSWORD_STRENGTH_RULES } from "../../utils/passwordPolicy";

/**
 * Live checklist for password strength (signup, set password, change password).
 */
export default function PasswordStrengthHints({ password = "", sx }) {
  return (
    <Box
      sx={{
        borderRadius: "10px",
        background: "rgba(15,23,42,0.03)",
        border: "1px solid rgba(15,23,42,0.08)",
        px: 1.5,
        py: 1.25,
        ...sx,
      }}
    >
      <Typography sx={{ fontSize: "0.7rem", fontWeight: 700, color: "#64748b", mb: 0.75, letterSpacing: "0.02em" }}>
        Password requirements
      </Typography>
      <Box component="ul" sx={{ m: 0, pl: 0, listStyle: "none" }}>
        {PASSWORD_STRENGTH_RULES.map((rule) => {
          const ok = rule.test(password);
          return (
            <Box
              component="li"
              key={rule.key}
              sx={{
                display: "flex",
                alignItems: "flex-start",
                gap: 0.75,
                py: 0.25,
                fontSize: "0.72rem",
                color: ok ? "#15803d" : "#64748b",
                fontWeight: ok ? 600 : 400,
              }}
            >
              <CheckCircleOutlineIcon
                sx={{ fontSize: 15, mt: "1px", opacity: ok ? 1 : 0.35, flexShrink: 0, color: "inherit" }}
              />
              <span>{rule.hint}</span>
            </Box>
          );
        })}
      </Box>
      <Typography sx={{ fontSize: "0.65rem", color: "#94a3b8", mt: 0.75, lineHeight: 1.45, wordBreak: "break-all" }}>
        Allowed special characters:{" "}
        <Box component="span" sx={{ fontFamily: "ui-monospace, monospace", color: "#64748b" }}>
          {PASSWORD_ALLOWED_SPECIALS}
        </Box>
      </Typography>
    </Box>
  );
}
